var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('DataTable',{attrs:{"url":_vm.url,"enable-delete":false,"descending":"","sortable":false,"enable-edit":false,"enable-add":false,"disable-search":"","title":false,"titles":_vm.titles,"fields-hidden-main":['updated_at'],"formatter":_vm.formatters}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }